import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=386d04a0&scoped=true&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d04a0",
  null
  
)

export default component.exports